module.exports = __webpack_public_path__ + "f08d97ddf52fac65d11ecc54bab1bb37.MP3";